import React from 'react';
import ToolCard from './ToolCard';

/**
 * RecommendedTools — "Start Here" strip. Renders 3–4 tools with the
 * top-priority tool visually featured (larger + spans two columns on
 * desktop). Falls back gracefully when there's only 1 or 2 tools.
 */
export default function RecommendedTools({ tools, onSelect }) {
  if (!tools || tools.length === 0) return null;
  const [featured, ...rest] = tools;
  return (
    <section aria-labelledby="cc-start-here-title" data-testid="cc-start-here">
      <header className="cc-section-head">
        <div className="cc-section-eyebrow">Start Here</div>
        <h2 id="cc-start-here-title" className="cc-section-title">Your best next step</h2>
        <span className="cc-section-title-underline" aria-hidden="true" />
        <p className="cc-section-sub">
          Pick one to keep moving. Everything you started shows below.
        </p>
      </header>
      <div className="cc-grid">
        <ToolCard tool={featured} featured onSelect={onSelect} />
        {rest.map((t) => (
          <ToolCard key={t.id} tool={t} onSelect={onSelect} />
        ))}
      </div>
    </section>
  );
}
